(ns frontend.test.read-only.view
  (:require
   [ui.components.read-only.view :as read-only]
   [ui.view.page.view :as page]))

(defn- sample-block
  [title body]
  [:section {:class "flex flex-col gap-2 rounded-lg border border-solid border-base-light-border-paler bg-base-lightest p-4"}
   [:h2 {:class "text-lg font-semibold"} title]
   body])

(defn view
  []
  [page/centered
   [:div {:class "flex w-full max-w-4xl flex-col gap-6 py-6"}
    [:div {:class "flex flex-col gap-1"}
     [:h1 {:class "text-2xl font-bold"} "Read-only rendering tests"]
     [:p {:class "text-sm text-base-light-text-lighter"}
      "Covers the generic helper used in survey settings detail rows and other read-only component surfaces."]]
    [sample-block
     "Single values"
     [:div {:class "grid grid-cols-1 gap-3 md:grid-cols-2"}
      [:div
       [:div {:class "text-xs uppercase tracking-wide text-base-light-text-lighter"} "Language"]
       [:div {:class "rounded bg-base-light p-3"}
        [:span (read-only/value-text {:data-type :data.type/language} :ENG)]]]
      [:div
       [:div {:class "text-xs uppercase tracking-wide text-base-light-text-lighter"} "Keyword"]
       [:div {:class "rounded bg-base-light p-3"}
        [:span (read-only/value-text {:data-type :data.type/keyword}
                                     :survey-cycle.status/active)]]]]]
    [sample-block
     "Multi values"
     [:div {:class "grid grid-cols-1 gap-3 md:grid-cols-2"}
      [:div
       [:div {:class "text-xs uppercase tracking-wide text-base-light-text-lighter"} "Languages"]
       [:div {:class "rounded bg-base-light p-3"}
        [read-only/multi-value-text {:values [:ENG :FIN :FRA]
                                     :data-type :data.type/language}]]]
      [:div
       [:div {:class "text-xs uppercase tracking-wide text-base-light-text-lighter"} "Keywords"]
       [:div {:class "rounded bg-base-light p-3"}
        [read-only/multi-value-text {:values [:rotation.type/monthly
                                              :rotation.type/quarterly
                                              :rotation.type/yearly]
                                     :data-type :data.type/keyword}]]]]]
    [sample-block
     "Fallbacks"
     [:div {:class "grid grid-cols-1 gap-3 md:grid-cols-2"}
      [:div
       [:div {:class "text-xs uppercase tracking-wide text-base-light-text-lighter"} "Empty"]
       [:div {:class "rounded bg-base-light p-3"}
        [read-only/multi-value-text {:values []
                                     :data-type :data.type/language
                                     :empty-text "Nothing selected"}]]]
      [:div
       [:div {:class "text-xs uppercase tracking-wide text-base-light-text-lighter"} "Custom render-item"]
       [:div {:class "rounded bg-base-light p-3"}
        [read-only/multi-value-text {:values [:ENG :FIN]
                                     :data-type :data.type/language
                                     :render-item (fn [value]
                                                    (str "[" (name value) "]"))}]]]]]]])
